/**
 * Normalize Quill disclaimer HTML before render.
 * Admin saves ql-indent-* classes; data-list is sometimes stripped in storage.
 */
export function normalizeDisclaimerHtml(html) {
  if (!html) {
    return "";
  }

  if (typeof document === "undefined") {
    return html;
  }

  const template = document.createElement("template");
  template.innerHTML = html;

  template.content.querySelectorAll("ol").forEach((ol) => {
    const items = ol.querySelectorAll(":scope > li");
    const hasIndent = Array.from(items).some((li) =>
      Array.from(li.classList).some((cls) => cls.startsWith("ql-indent-"))
    );
    const hasDirectDataList = Array.from(items).some((li) =>
      li.hasAttribute("data-list")
    );

    // Nested ul/ol inside li = plain HTML from Quill; keep browser list rendering.
    const hasNestedList = Array.from(items).some((li) =>
      li.querySelector(":scope > ul, :scope > ol")
    );
    if (hasNestedList) {
      return;
    }

    if (!hasIndent && !hasDirectDataList) {
      return;
    }

    ol.classList.add("disclaimer-quill-list");

    items.forEach((li) => {
      const indentClass = Array.from(li.classList).find((cls) =>
        cls.startsWith("ql-indent-")
      );
      const existingList = li.getAttribute("data-list");

      if (indentClass && !existingList) {
        li.setAttribute("data-list", "ordered");
      }

      if (!existingList && !indentClass) {
        li.setAttribute("data-list", "ordered");
      }

      li.style.paddingLeft = "";
      li.style.marginLeft = "";
    });
  });

  template.content.querySelectorAll("ul").forEach((ul) => {
    // Skip nested ul inside ol > li — plain HTML bullets render via CSS.
    if (ul.closest("ol > li")) {
      return;
    }

    const hasIndent = Array.from(ul.querySelectorAll(":scope > li")).some((li) =>
      Array.from(li.classList).some((cls) => cls.startsWith("ql-indent-"))
    );
    if (!hasIndent && !ul.querySelector(":scope > li[data-list]")) {
      return;
    }

    ul.classList.add("disclaimer-quill-list");

    ul.querySelectorAll(":scope > li").forEach((li) => {
      if (!li.getAttribute("data-list")) {
        li.setAttribute("data-list", "bullet");
      }

      li.style.paddingLeft = "";
      li.style.marginLeft = "";
    });
  });

  return template.innerHTML;
}
